import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { loadFonts } from "./plugins/webfontloader";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import * as directives from "vuetify/directives";
import { VDateInput } from "vuetify/labs/VDateInput";
import "./assets/styles/fonts.css";
import "./assets/styles/colors.css";
import "./assets/styles/containers.css";
import "./assets/styles/buttons.css";
import "./assets/styles/icons.css";
import axios from "axios";
import SharedService from "./utils/shared.service";
import { createGtm } from "@gtm-support/vue-gtm";
import "@mdi/font/css/materialdesignicons.css";
import VueColor from '@ckpack/vue-color';
import { eventBus } from '@/utils/eventBus'; // Add this import
loadFonts();


//To hide console logs in production and development
if (
    process.env.NODE_ENV === 'production' ||
    process.env.NODE_ENV === 'development'
) {
    console.log = function () {};
    console.info = function () {};
    console.debug = function () {};
}

// Set base URL
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

// Automatically add token & role if present (on reload)
axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("accessToken");
  const role = sessionStorage.getItem("userRole");

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  if (role) {
    config.headers["role"] = role;
  }
  return config;
});

// Response interceptor: handle session timeout
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('🔍 Axios error intercepted:', error.response?.status);
    if (error.response?.status === 401) {
      console.log('❌ 401 Error - Triggering session timeout');
      console.log('📊 EventBus before trigger:', eventBus.showSessionTimeout);
      
      // Trigger session timeout dialog using event bus
      eventBus.triggerSessionTimeout();
      
      console.log('📊 EventBus after trigger:', eventBus.showSessionTimeout);
    }
    return Promise.reject(error);
  }
);

const vuetify = createVuetify({
  components: {
    VDateInput,
  },
  directives,
  icons: {
    defaultSet: "mdi",
  },
});

const sharedService = new SharedService();

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(VueColor)
  .provide("sharedService", sharedService)
  .mount("#app");
